module.exports = __webpack_public_path__ + "lock_2.d9d3a67a440e99658554115233918855.svg";